import { Table, TableBody, TableHead, TableHeader, TableRow } from "@/ds/shadcn/components/ui/table";
import { ListInfiniteScroller } from "@/features/common/components/dataview/ListInfiniteScroller";
import type { DataViewBaseProps, DataViewComponentTypeProps, DataViewDataProps } from "@/features/common/components/dataview/DataViewTypes";
import { useDataItems } from "@/features/common/components/dataview/DataViewTypes";
import type { ComponentType } from "react";
import React from "react";

export type DataViewListProps<T, U = undefined> = {
	listViewHeaderLabels: string[];
	listViewHeaderClassNames?: string[];
	listComponent: ComponentType<DataViewComponentTypeProps<T, U>>;
};

export const DataViewList = <T, U = undefined>(props: DataViewBaseProps<T, U> & DataViewDataProps<T> & DataViewListProps<T, U>): React.JSX.Element => {
	const {
		listViewHeaderLabels,
		listViewHeaderClassNames,
		listComponent: ListComponent,
		getKey,
		additionalProps,
		scrollRef
	} = props;

	const forQuery = "forQuery" in props ? props.forQuery : undefined;
	const rows = useDataItems(props);

	return (
		<Table className="table-fixed w-full">
			<TableHeader>
				<TableRow>
					{
						listViewHeaderLabels.map((x, i) => (
							<TableHead key={i} className={listViewHeaderClassNames?.[i]}>
								{x}
							</TableHead>
						))
					}
				</TableRow>
			</TableHeader>
			<TableBody>
				{
					rows.map(x => {
						const componentProps = {
							...x,
							...additionalProps
						} as DataViewComponentTypeProps<T, U>;

						return <ListComponent key={getKey(x)} {...componentProps} />;
					})
				}

				{
					forQuery &&
					<ListInfiniteScroller colSpan={listViewHeaderLabels.length} forQuery={forQuery} scrollRef={scrollRef} />
				}
			</TableBody>
		</Table>
	);
};
